import React, { useEffect, useState } from 'react';
import { Form, Button, Card, Alert, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faCheckCircle, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import './ResetPassword.scss';
import { useDispatch } from 'react-redux';
import { resetPassword } from '../../actions/usuarioActions';

const ResetPassword = () => {
    const initialstate={
        password: '',
        token: '',
    }

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [token, setToken] = useState("");
    const [datos, setDatos] = useState(initialstate);
    const dispatch = useDispatch();


    const handleSubmit = (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setMessage('Las contraseñas no coinciden.');
            return;
        }else{
            setDatos({
                password: password,
                token: token
            })
            dispatch(resetPassword(datos))
        }
        setMessage('Tu contraseña ha sido actualizada correctamente.');
    };

    useEffect(() => {
        // Obtener los parámetros de la URL
        const params = new URLSearchParams(window.location.search);
        // Recuperar el valor del token
        const tokenValue = params.get("token");
        if (tokenValue) {
            setToken(tokenValue);
        }
    }, []);

    useEffect(() => {
        if (!token) {
            setMessage('No se ha proporcionado un token válido.');
        }else{
            setMessage('Token valido');
        }
    }, [token]);

    return (
        <div className='bg-save-password'>
            <div className="container d-flex justify-content-center align-items-center container-save-password">
                <Card className="shadow-lg card-save-password">
                    <Card.Body className="p-4">
                        <Card.Title className="text-center mb-3 text-primary">Guardar Nueva Contraseña</Card.Title>
                        <Card.Text className="text-center text-muted mb-4">
                            Ingresa tu nueva contraseña y confírmala para actualizarla.
                        </Card.Text>
                        <Form onSubmit={handleSubmit}>

                            <Form.Group className="mb-3" controlId="password">
                                <Form.Label>Nueva Contraseña</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faKey} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Ingresa tu nueva contraseña"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        className="save-password-input"
                                    />
                                    <InputGroup.Text
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="cursor-pointer"
                                    >
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>


                            <Form.Group className="mb-3" controlId="confirmPassword">
                                <Form.Label>Confirmar Contraseña</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faKey} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type={showConfirmPassword ? "text" : "password"}
                                        placeholder="Confirma tu nueva contraseña"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                        className="save-password-input"
                                    />
                                    <InputGroup.Text
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        className="cursor-pointer"
                                    >
                                        <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>

                            <Button type="submit" variant="primary" className="w-100">
                                Guardar Contraseña
                            </Button>
                        </Form>
                        {message && (
                            <Alert
                                variant={message === 'Tu contraseña ha sido actualizada correctamente.' ? 'success' : 'danger'}
                                className="mt-3 text-center"
                            >
                                <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                                {message}
                            </Alert>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default ResetPassword;
